"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sleep = exports.css = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _aphrodite = require("aphrodite");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var cssRecursive = function cssRecursive(_ref) {
  var configs = _ref.configs,
      mergedStyles = _ref.mergedStyles,
      styleFragment = _ref.styleFragment;

  var _iterator = _createForOfIteratorHelper(configs),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var config = _step.value;

      if (!config) {
        continue;
      }

      if (typeof config === "string") {
        mergedStyles.push((0, _aphrodite.css)(styleFragment));
        mergedStyles.push(config);
        styleFragment.length = 0; // an awesome way to empty an array
      } else if (Array.isArray(config)) {
        cssRecursive({
          configs: config,
          mergedStyles: mergedStyles,
          styleFragment: styleFragment
        });
      } else if ((0, _typeof2["default"])(config) === "object") {
        // eslint-disable-next-line no-underscore-dangle
        if (config._len == null) {
          // config is a plain style object
          styleFragment.push(_aphrodite.StyleSheet.create({
            inline: config
          }).inline);
        } else {
          // config is a return value from StyleSheet.create()
          styleFragment.push(config);
        }
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
};

var css = function css() {
  /*
   * [styleObj1, styleObj2, className1, styleObj3]
   * will be merged into:
   * [styleObj1_styleObj2, className1, styleObj3]
   */
  var mergedStyles = []; // if you find this please fix the any types (legacy)

  var styleFragment = [];

  for (var _len = arguments.length, configs = new Array(_len), _key = 0; _key < _len; _key++) {
    configs[_key] = arguments[_key];
  }

  cssRecursive({
    configs: configs,
    mergedStyles: mergedStyles,
    styleFragment: styleFragment
  });
  mergedStyles.push((0, _aphrodite.css)(styleFragment));
  return mergedStyles.join(" ");
};

exports.css = css;

var sleep = function sleep(interval) {
  return new Promise(function (resolve) {
    setTimeout(function () {
      return resolve(true);
    }, interval);
  });
};

exports.sleep = sleep;